module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./RegisterStoreView.js"));
	}, "RegisterStoreView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RegisterStoreView!./src/pages/Register/RegisterStore/RegisterStoreView.js
// module id = 1326
// module chunks = 418